import { render } from "./ProfilePositionEdit.vue?vue&type=template&id=7443bec4&lang=pug"
import script from "./ProfilePositionEdit.vue?vue&type=script&lang=js"
export * from "./ProfilePositionEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__